import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FilePreviewOverlayComponent } from './file-preview-overlay.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [FilePreviewOverlayComponent],
  exports: [FilePreviewOverlayComponent],
})
export class FilePreviewOverlayModule {}
